// SPDX-FileCopyrightText: 2024 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var documentSlice = createSlice({
    name: "documents",
    initialState: initialState,
    reducers: {
        setDocument: function (state, action) {
            state[action.payload.id] = action.payload;
            return state;
        },
    },
});
export var setDocument = documentSlice.actions.setDocument;
export var selectDocumentById = function (documentId) { return function (state) {
    return state.documents[documentId];
}; };
export default documentSlice.reducer;
